import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const ConversationApiUtils = {
  // fetch up to 30 conversations. Add load more in the future
  fetch(page, activeConversationId = null) {
    let query = '?page=' + page;
    if (activeConversationId !== null) {
      query += '&activeConversationId=' + activeConversationId;
    }
    return xhr(ApiConstants.fetchConversations + query);
  },

  // fetchConversations(page, activeConversationId=null) {
  //   let query = "?page=" + page;
  //   if (activeConversationId !== null) {
  //     query += "&activeConversationId=" + activeConversationId;
  //   }
  //   return xhr(ApiConstants.fetchConversations + query);
  // },

  loadMoreMessages(conversationId, lastMessageId, lastMessageSentAt) {
    var query = '';
    let spcid = conversationId.split('/');
    let cid = spcid[spcid.length - 1];
    let lid = lastMessageId ? lastMessageId : '';
    let lSentAt = lastMessageSentAt ? parseInt(lastMessageSentAt) : '';
    if (lid !== '' && lSentAt !== '') {
      query = `?sent=${lSentAt}&lid=${lid}`;
    }
    return xhr(ApiConstants.fetchMessages + cid + '/messages' + query);
  },

  sendMessage(messageObj) {
    let a = messageObj.conversation_id.split('/');
    const cid = a[a.length - 1];
    return xhr(ApiConstants.sendMessage + cid + '/messages', {
      method: 'post',
      body: JSON.stringify({ message_obj: messageObj }),
    });
  },
};

export default ConversationApiUtils;
